module.exports = __webpack_public_path__ + "static/media/logo.687a09b4.png";